import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';
import { CURRENT_ORDER_ACTIONS } from '@ispm/test/constants/current-order.constants';
import { IResourcesMap } from '@ispm/workflow/interfaces/resource-map.interface';

export interface ICurrentOrderState {
  patientId: string;
  testId: string;
  revisionId: string,
  patientAnalysisById: any;
  patientAnalysis: any;
  ordersCount: number;
  isNewOrder: boolean;
  skipNotesFetch: boolean;
  patient: any;
  resourceMap: IResourcesMap;
  qcResults: any;
  workflow: any;
  notes: any;
}

const InitCurrentOrderState: ICurrentOrderState = {
  patientId: '',
  testId: '',
  revisionId: '',
  patientAnalysisById: null,
  patientAnalysis: null,
  ordersCount: -1,
  isNewOrder: false,
  skipNotesFetch: false,
  patient: null,
  resourceMap: null,
  qcResults: null,
  workflow: null,
  notes: null
};

export function currentOrderReducer(state: ICurrentOrderState = InitCurrentOrderState,
                                       action: IgenomicsAction): ICurrentOrderState {
  let newState;
  switch (action.type) {
    case CURRENT_ORDER_ACTIONS.INIT_CURRENT_ORDER_STATE:
      return InitCurrentOrderState;
    case CURRENT_ORDER_ACTIONS.SET_PATIENT_ID:
      newState = Object.assign({ }, state);
      newState.patientId = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_REVISION_ID:
      newState = Object.assign({ }, state);
      newState.revisionId = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_TEST_ID:
      newState = Object.assign({ }, state);
      newState.testId = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_CURRENT_ORDER:
      newState = Object.assign({ }, state);
      newState.patientAnalysisById = action.payload; //new Proxy(immutable.List(action.payload), { });
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_ALL_ORDERS:
      newState = Object.assign({ }, state);
      newState.patientAnalysis = action.payload; //new Proxy(immutable.List(action.payload), { });
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_ORDERS_COUNT:
      newState = Object.assign({ }, state);
      newState.ordersCount = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_IS_NEW_ORDER:
      newState = Object.assign({ }, state);
      newState.isNewOrder = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_SKIP_NOTES_FETCH:
        newState = Object.assign({ }, state);
        newState.skipNotesFetch = action.payload;
        return newState;
    case CURRENT_ORDER_ACTIONS.SET_PATIENT:
      newState = Object.assign({ }, state);
      newState.patient = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_RESOURCE_MAP:
      newState = Object.assign({ }, state);
      newState.resourceMap = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_QC_RESULTS:
      newState = Object.assign({ }, state);
      newState.qcResults = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_WORKFLOW_DATA:
      newState = Object.assign({ }, state);
      newState.workflow = action.payload;
      return newState;
    case CURRENT_ORDER_ACTIONS.SET_NOTES_DATA:
      newState = Object.assign({ }, state);
      newState.notes = action.payload;
      return newState;

    case CURRENT_ORDER_ACTIONS.UPDATE_FIELDS:
      // newState = Object.assign({ }, state);
      // newState.allOrders = action.payload.allTests;
      // newState.currentOrder = Object.assign(state.currentOrder, action.payload.current);
      // newState.patientId = action.payload.patientId;
      // return newState;
    default:
      return state;
  }
}
